import { listenerMiddleware } from "../listenerMiddleware";
import { loadingModalClosed, stageUpdated } from "../slices/loadingSlice";

export const SUCCESS_MODAL_DISPLAY_DURATION = 1000;

export const registerLoadingListeners = () =>
  listenerMiddleware.startListening({
    actionCreator: stageUpdated,
    effect: async (_, listenerApi) => {
      listenerApi.cancelActiveListeners();

      const {
        loading: { stages }
      } = listenerApi.getState() as {
        loading: { stages: { status: string }[] };
      };

      if (stages.every((stage) => stage.status === "success")) {
        await listenerApi.delay(SUCCESS_MODAL_DISPLAY_DURATION);
        listenerApi.dispatch(loadingModalClosed());
      }
    }
  });
